export default "__VITE_ASSET__a5416b05__"